// extracted by mini-css-extract-plugin
export default {"aboutUsPageMain":"AboutUsPage_aboutUsPageMain__-wmV5","legalInfo":"AboutUsPage_legalInfo__fO2yt","aboutTeam":"AboutUsPage_aboutTeam__CIMXa","whatToDo":"AboutUsPage_whatToDo__h6Oio"};